import './_specific-objectives.scss';

export default function SpecificObjectives() {
    const $specificObjectives = document.querySelectorAll('.specific-objectives');

    if($specificObjectives.length) {
        $specificObjectives.forEach($item => {
            const $btn = $item.querySelector('.objectives-wrapper.rows .btn-white') as HTMLElement;
            const $title = $item.querySelector('.objectives-wrapper.rows .title') as HTMLElement;

            if($title) {
                function resize(_matches: any) {
                    if(window.innerWidth > 768 && $btn) {
                        $title.style.maxWidth = `calc(100% - ${$btn.clientWidth}px)`;
                    } else {
                        $title.style.maxWidth = '100%';
                    }
                }

                const mediaQuery = window.matchMedia('(max-width: 768px)');

                mediaQuery.removeEventListener('change', function () {});
                mediaQuery.addEventListener('change', (e) => resize(e.matches));

                resize(mediaQuery.matches);
            }
        })
    }
}